/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Personas_Name_MaxInputs */



/**
* | output |
* | --- |
* | "Name must be at most {count} characters." |
*
* @param {Personas_Name_MaxInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const personas_name_max = /** @type {((inputs: Personas_Name_MaxInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personas_Name_MaxInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Name darf maximal ${i?.count} Zeichen lang sein.`)
	return /** @type {LocalizedString} */ (`Name must be at most ${i?.count} characters.`)
});